const LICENSE_INFORMATION_HOLDER_TYPES = {
  Organization: 'org',
  OrgUnit: 'org-unit'
};

export default LICENSE_INFORMATION_HOLDER_TYPES;
